module.exports = __webpack_public_path__ + "static/img/bg.94e282a0.png";